import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class PrintService {
    printing = new BehaviorSubject<boolean>(false);
    
    constructor() {}

    async print(title: string | undefined = undefined) {
        this.printing.next(true);
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                const title = window.document.title;
                if (title) {
                    window.document.title = title;
                }
                window.print();
                window.document.title = title;
                
                this.printing.next(false);
                resolve(true);
            }, 200);
        })
    }
}


// WEBPACK FOOTER //
// ./src/services/print-service.ts